<template>
  <div style="display: none;"></div>
</template>

<script>
export default {
  name: 'BlockShortcuts',
  mounted() {
    document.addEventListener("keydown", this.blockShortcuts);
    document.addEventListener("contextmenu", this.blockContextMenu);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.blockShortcuts);
    document.removeEventListener("contextmenu", this.blockContextMenu);
  },
  methods: {
    async blockShortcuts(e) {
      const user = this.$store.getters.getUser;
      if (!user.development_tools && this.$store.getters.getLoggedIn) {
        const key = e.key.toLowerCase();
        // F12
        if (e.key === "F12") {
          this.logView()
          e.preventDefault();
          this.showBlockedMessage();
        }

        // CTRL + U
        if (e.ctrlKey && key === "u") {
          this.logView()
          e.preventDefault();
          this.showBlockedMessage();
        }

        // CTRL + SHIFT + I
        if (e.ctrlKey && e.shiftKey && key === "i") {
          this.logView()
          e.preventDefault();
          this.showBlockedMessage();
        }

        // CTRL + C
        // if (e.ctrlKey && key === "c") {
        //   this.logView()
        //   e.preventDefault();
        //   this.showBlockedMessage();
        // }
      }
    },
    async blockContextMenu(e) {
      const user = this.$store.getters.getUser;
      if (!user.development_tools && this.$store.getters.getLoggedIn) {
        // this.logView()
        e.preventDefault();
        this.showBlockedMessage();
      }
    },
    showBlockedMessage() {
      this.$store.dispatch('setModalMessage', {
        message: "Atalho bloqueado nessa página",
        type: "error",
      });
    },
    async logView() {
      const data = {
        'info': 'command',
        'module': null,
        'entityId': null
      }

      const dataJson = JSON.stringify(data);

      const requestOptions = await this.$store.dispatch('getRequestOptions', { addAuth: true, method: "POST", dataJson: dataJson });
      let url = "/system-helper/log-view";

      const dataRequest = await this.$store.dispatch('sendRequest', { url: url, requestOptions: requestOptions })
      if (dataRequest.request.status == 422) {
        this.$store.dispatch('setModalMessage', {
          message: dataRequest.response.message,
          type: "error",
        });
      }
      return false
    },
  }
};
</script>
